require('aws-sdk/lib/node_loader');
var AWS = require('aws-sdk/lib/core');
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['smswounifieddashboardservicelambda'] = {};
SMSWOUnifiedDashboardServiceLambda = Service.defineService('smswounifieddashboardservicelambda', ['2018-05-10']);
Object.defineProperty(apiLoader.services['smswounifieddashboardservicelambda'], '2018-05-10', {
    get: function get() {
        var model = require('./c2j.json');
        /* Currently no waiters or paginators defined for UserPreferenceService
        model.paginators = require('../apis/c2j.paginators.json').pagination;
        model.waiters = require('../apis/c2j.waiters2.json').waiters;
        */
        return model;
    },
    enumerable: true,
    configurable: true
});

module.exports = SMSWOUnifiedDashboardServiceLambda;